import {AfterViewInit, Directive, OnDestroy} from '@angular/core';

@Directive({
  selector: '[appHighlightContainer]'
})
export class HighlightContainerDirective implements AfterViewInit, OnDestroy {

  constructor() {
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
  }

}
